import {AnimalMediaModel} from '../../../modules/animals/models/animal-media.model';
import {ChangeDetectorRef, Component, Input, OnChanges, OnInit} from '@angular/core';
import {take} from 'rxjs';
import {AnimalModel} from 'src/app/modules/animals/models/animal.model';
import {AnimalImagesRepository} from 'src/app/modules/animals/states/animal-images.repository';
import {AssetService} from '../../services/asset.service';

@Component({
  selector: 'app-animal-image-container',
  templateUrl: './animal-image-container.component.html',
  standalone: false
})
export class AnimalImageContainerComponent implements OnInit, OnChanges {
  @Input() id?: number | undefined;
  @Input() variant?: string = '';
  @Input() preview?: boolean = false;
  @Input() animal: AnimalModel | null = null;

  imageUrl: string | null | undefined = '';
  isLoading: boolean = false;

  constructor(
    private readonly _cdr: ChangeDetectorRef,
    private readonly _animalImagesRepository: AnimalImagesRepository,
    private readonly _assetService: AssetService
  ) {
  }

  ngOnInit(): void {
    if (this.animal) {
      this._animalImagesRepository.getImages(this.animal.id).pipe(take(1)).subscribe(() => {
          this.getPreviewImage();
      });
    }
    if (!this.preview && this.id) {
      this.getAnimalImage(this.id);
    }
  }

  ngOnChanges(): void {
    if (!this.preview && this.id) {
      this.getAnimalImage(this.id);
    } else {
      this.getPreviewImage();
    }
  }

  getAnimalImage(imageId: number) {
    if (!imageId) {
      return;
    }

    this.isLoading = true;
    this._animalImagesRepository.getImageById(imageId).pipe(take(1)).subscribe((image: AnimalMediaModel | null) => {
      if (image && this.variant && image.variants[this.variant]?.url) {
        this.imageUrl = this._assetService.getAssetUrl(image.variants[this.variant].url);
        this.isLoading = false;
      } else if (image && image.variants['web-detail']?.url) {
        this.imageUrl = this._assetService.getAssetUrl(image.variants['web-detail'].url);
        this.isLoading = false;
      } else {
        this.imageUrl = this.getFallbackImage();
        this.isLoading = false;
      }
      this._cdr.detectChanges();
    });
  }


  getPreviewImage() {
    if (!this.animal?.previewImageId) {
      this.imageUrl = this.getFallbackImage();
      this.isLoading = false;
      return;
    }

    this.isLoading = true;
    this.variant = 'thumbnail';
    this.getAnimalImage(this.animal.previewImageId);
    this._cdr.detectChanges();
  }

  getFallbackImage(): string {
    const category = this.animal?.category?.toLowerCase();
    if (category) {
      return `./assets/images/animals/default_${category}.png`;
    }
    return './assets/images/animals/default_dog.png';
  }
}
